export default "__VITE_ASSET__DJTyya5p__"